var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Order',{ref:"order"}),_c('dispatch',{ref:"dispatch"}),_c('feeReimbursement',{ref:"feeReimbursement"}),_c('vehicleRepair',{ref:"vehicleRepair"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }